import { Establishment } from '@/core/models/establishment.model'
import { Tag, baseApi } from './base'

import { cacher } from '@/utils/rtkQueryCacheUtils'

export type Contract = {
  _id: string
  establishment: Establishment
  licenseUsages: LicenseUsage[]
  name: string
}

type LicenseUsage = {
  license: string
  quantity: number
  licensees: string[]
}

export type CreateContractParams = {
  establishment: string
  licenseUsages: Pick<LicenseUsage, 'license' | 'quantity'>[]
  name: string
}

export type UpdateContractParams = {
  establishment?: string
  licenseUsages?: Partial<LicenseUsage>[]
  name?: string
}

export const contractApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getContract: builder.query<Contract, string>({
      query: (contractId) => `/contracts/${contractId}`,
    }),
    getContractByEstablishment: builder.query<Contract, string>({
      query: (establishmentId) => `/contracts/establishments/${establishmentId}`,
    }),
    getContracts: builder.query<Contract[], void>({
      query: () => `/contracts`,
      providesTags: cacher.providesList(Tag.CONTRACT),
    }),
    createContract: builder.mutation<Contract, CreateContractParams>({
      query: (body) => ({
        url: '/contracts',
        method: 'POST',
        body,
      }),
      invalidatesTags: cacher.invalidatesList(Tag.CONTRACT),
    }),
    updateContract: builder.mutation<Contract, UpdateContractParams & { id: string }>({
      query: ({ id: contractId, ...body }) => ({
        url: `/contracts/${contractId}`,
        method: 'PUT',
        body,
      }),
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedContract } = await queryFulfilled
          dispatch(
            contractApi.util.updateQueryData('getContract', id, (draftContract) => {
              Object.assign(draftContract, updatedContract)
            })
          )
        } catch (error) {
          console.log(error)
        }
      },
    }),
    deleteContract: builder.mutation<Contract, string>({
      query: (contractId) => ({
        url: `/contracts/${contractId}`,
        method: 'DELETE',
      }),
      invalidatesTags: cacher.invalidatesList(Tag.CONTRACT),
    }),
  }),
  overrideExisting: false,
})
